/**
 * Same label the API returns: "Mon 28 Sep 2026 · 9:00am – 3:00pm (Jane Smith)".
 * Used when the timesheet is already known (Care Watch, a saved report) and
 * the finished-timesheet list is not loaded.
 */
export const formatTimesheetLabel = ({ date, start, end, workerName }) => {
  const day = formatDay(date);
  const from = formatClock(start);
  const to = formatClock(end);
  let when = day;
  if (from && to) when = `${day} · ${from} – ${to}`.trim();
  else if (from) when = `${day} · ${from}`.trim();
  const name = (workerName || "").trim();
  if (!name) return when;
  return `${when} (${name})`.trim();
};

const formatDay = (value) => {
  if (!value) return "";
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const parsed = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${days[parsed.getDay()]} ${parsed.getDate()} ${months[parsed.getMonth()]} ${parsed.getFullYear()}`;
};

const formatClock = (value) => {
  if (!value) return "";
  const match = String(value).match(/(\d{1,2}):(\d{2})/);
  if (!match) return "";
  let hour = Number(match[1]);
  const minute = match[2];
  const suffix = hour >= 12 ? "pm" : "am";
  hour = hour % 12 || 12;
  return `${hour}:${minute}${suffix}`;
};
